import React, { useEffect, useRef, useState } from 'react'
import {
  message,
  Button,
  Col,
  Card,
  ConfigProvider,
  Layout,
  Pagination,
  Popconfirm,
  Row,
  Statistic,
  Table,
  Tag,
} from 'antd'
import ClusterDetailStyle from './cluster-detail.module.less'
import lodaingGif from '../../../../static/image/task/loding.gif'

export interface Props {
  mode: string
}

const ClusterDetail: React.FC<Props> = (props) => {
  const { mode } = props
  const [isLoading, setIsLoading] = useState(false)

  const restartCluster = () => {
    setIsLoading(true)

    setTimeout(() => {
      setIsLoading(false)
      message.success("重启集群成功！")
      // message.error("重启集群失败！")
    }, 2000)
  }

  return (
    <Card
      title={'集群概况'}
      extra={
        <Button
          onClick={restartCluster}
          style={{ backgroundColor: '#9a3232', borderRadius: 50 }}
          type={'primary'}
        >
          重启集群
        </Button>
      }
      style={
        mode === 'oam'
          ? { width: '100%', margin: 20, borderRadius: 10, overflow: 'hidden' }
          : mode === 'college-oam'
          ? { width: '97%', margin: 20, borderRadius: 10, overflow: 'hidden' }
          : {}
      }
    >
      {!isLoading && (
        <div className={ClusterDetailStyle.iframediv}>
          <iframe
            id="iframeCluster"
            src="http://123.57.82.32:8088/cluster"
            frameBorder="0"
          ></iframe>
        </div>
      )}
      {isLoading && (
        <div className={ClusterDetailStyle.loadingContain}>
          <img width={50} height={50} src={lodaingGif} alt="" />
          <div>集群正在重启......</div>
        </div>
      )}
    </Card>
  )
}

export default ClusterDetail
